import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Reveal } from './Reveal';
import { WaitlistCTA } from '../WaitlistCTA';
export function SectionTwo() {
  return <section className="relative flex min-h-screen flex-col supports-[height:100svh]:min-h-[100svh]" data-id="element-4688" data-mp="1zdjjqmkwa7ik">
      <div className="relative flex flex-1 flex-col justify-center gap-10 px-5 pt-24 sm:flex-row sm:items-center sm:justify-between sm:gap-8 sm:px-8 sm:pt-0 md:px-12" data-id="element-4689" data-mp="1udyjm8tznt49">
        <h2 className="max-w-sm text-4xl font-title font-medium leading-[1.05] tracking-tight text-white drop-shadow-lg sm:text-5xl md:text-6xl" data-id="element-4690" data-mp="2n4gmp9uppuho">
          <Reveal delay={100} data-id="element-4691" data-mp="2d6iy2l8xxvoj">Architect</Reveal>
          <Reveal delay={220} data-id="element-4692" data-mp="2d57ualfhwnxf">
            <span className="italic font-light" data-id="element-4693" data-mp="2d8m0k4ra5ha5">anything.</span>
          </Reveal>
        </h2>
      </div>

      <div className="relative flex flex-col gap-8 px-5 pb-16 sm:px-8 md:px-12 md:pb-20" data-id="element-4694" data-mp="11rm735t74wej">
        <Reveal delay={460} data-id="element-4695" data-mp="11p9hq7l3zjrg">
          <p className="max-w-xs text-sm leading-relaxed text-white/85 drop-shadow-md" data-id="element-4696" data-mp="ws17ct67ck0r">
            Describe the outcome you want and Giga designs the workflow to get
            there—wiring up the steps, tools, and logic. From idea to working
            system, it builds whatever you can imagine.
          </p>
        </Reveal>
        <Reveal delay={580} data-id="element-4697" data-mp="a27wx3yp2m18">
          <WaitlistCTA className="group inline-flex items-center justify-center gap-2 rounded-full bg-[#EA580C] px-8 py-3 text-sm font-semibold text-white shadow-lg shadow-[#EA580C]/20 transition-all duration-300 hover:bg-[#d24e09] hover:scale-105" data-id="element-4698" data-mp="a53xz15u9qtw">
            Get started for free
            <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-0.5" data-id="element-4699" data-mp="62qpi4zpjetf" />
          </WaitlistCTA>
        </Reveal>
      </div>
    </section>;
}